<div class="tile-container">
  <mad-tile label="Large Success" variant="success" size="lg" />
  <mad-tile label="Medium Error" variant="error" icon="cancel" />
  <mad-tile label="Medium Info" variant="info" icon="update" />
  <mad-tile label="Small Warning" variant="warning" icon="priority_high" size="sm" />
</div>
